import i18n, { DefaultLanguage } from 'app/i18/i18.ts'

import { setSettingForApp } from 'entities/user/module/app-settings'
import userStore from 'entities/user/module/user-store'

const validLanguages = ['ru', 'ky', 'en'] as const

const getValidLanguage = (lang: string | null): string => {
  if (
    !lang ||
    !validLanguages.includes(lang as (typeof validLanguages)[number])
  ) {
    return DefaultLanguage
  }
  return lang
}

export const initLanguageFromQuery = (langParam: string | null): void => {
  let language: string

  if (langParam) {
    language = getValidLanguage(langParam)
  } else {
    const savedLanguage = userStore.getClientStateString('language')
    language = savedLanguage ? getValidLanguage(savedLanguage) : DefaultLanguage
  }

  i18n.changeLanguage(language)
  void setSettingForApp({ key: 'language', value: language })
}
